import _BaseAPIService from "./_BaseAPIService";

const apiService = _BaseAPIService.instance;
const SVGService = {
  getList: async () => {
    const response = await apiService.get("/home-banners");
    return response.data;
  },
  getbySlug: async (id) => {
    const response = await apiService.get(`/home-banners/${id}`);
    return response.data;
  },
};

export default SVGService;
